import React, { useEffect } from 'react';
import BOM from "@system/config/bom";
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import NavigateToProductDetail from "../../../component/custom/NavigateToProductDetail";
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useSystem } from "src/hooks/system";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const AddedToBomPopup = (props) => {
    const { data, SetStatus } = props;
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    let { single_product, bomNoMatchType, bomId, bomDetailId } = data
    const [{ bom_project_list, bom_detail_by_bom_id, bom_detail_by_bom_id_type }, { }, { add_part_to_bom, swap_part_number, create_params_for_add_part_to_bom }] = useBOMStore();
    const [{ }, { get_pricing_by_id, get_current_price_by_quantity, get_inventory_by_id }, { }] = useProductInventoryPriceStore();
    const bom_id = System.getParams().bomId;
    const { translation:t  } = System;
    const [,{ get_quantity_format }] = useSystem();
    useEffect(() => {
        async function fetchHere() {
            if (data) {
                let params = await create_params_for_add_part_to_bom({ ...single_product, bomIds: [bomId] })

                if (bomDetailId && bomId && bomNoMatchType === 'true') {
                    params.bomDetailId = bomDetailId
                    params.bomId = bomId
                    params.designWinFlag = single_product?.DesignWinFlag
                    await swap_part_number(params)
                    bomNoMatchResolveEvent(params)
                } else {
                    await add_part_to_bom(params)
                }
            }
        }

        fetchHere()
    }, [data]);

    const getLatestQuantity = () => {
        if (CART_BEFORE_TO_SEND_SERVER && single_product?.ItemNumber &&
            CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber] &&
            CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber].quantityUpdateToCart
        ) {
            return CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber].quantityUpdateToCart;
        }
        return single_product.QtyMin !== null ? single_product.QtyMin : 0;
    }

    const onHide = (action = true) => {
        SetStatus(false)
    };
    
    const getLatestQtyAndPrice = get_current_price_by_quantity(get_pricing_by_id({ ItemNumber: single_product.ItemNumber }), getLatestQuantity(), true);
    const bomNoMatchResolveEvent = (params) => {
        let productArr = [single_product]?.map((x) => {
            let priceObj = get_pricing_by_id({ ItemNumber: x.ItemNumber })
            return {
                ...x,
                qas: get_inventory_by_id(x?.ItemNumber)?.inventoryQty || 0,
                unitPrice: getLatestQtyAndPrice?.marketPrice || x.unitPrice || priceObj?.marketPrice || 0,
                subtotal: x.subtotal || (getLatestQtyAndPrice?.marketPrice * x?.QtyMin) || 0,
                quantity: params.quantity || x.Quantity || priceObj?.quantity,
                priceSource: priceObj?.priceSource || ''
            }
        });
        let bomInfo = {
            bomId: bom_detail_by_bom_id?.bomId,
            bomTitle: bom_detail_by_bom_id?.bomName,
            bomProjectName: bom_project_list && bom_project_list[bom_detail_by_bom_id?.projectId]?.projectName || '',
            newBOM: bom_detail_by_bom_id?.newBOM,
            sourceOfBOM: bom_detail_by_bom_id?.source || '',
            exactMatchesReturned: bom_detail_by_bom_id_type?.Exact?.count,
            multipleMatchesReturned: bom_detail_by_bom_id_type?.Multiple?.count,
            noMatchesReturned: bom_detail_by_bom_id_type?.NoMatch?.count,
        };
        HelperAnalyticsEvent.bomNoMatchResolve({
            productList: productArr,
            bomInfo: bomInfo
        })
    }
    
    return (
        <>
            <div className="avnet-modal modal-800">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={onHide}>×</button>
                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel">{t('addedToYourBom')}</h3>
                    </div>
                    <div className="modal-body">
                        <p className="text-center mb-4">
                            {t('thisItemHasAddToExactMatch')} "{t('exactMatches')}"
                        </p>
                        <div className='bs5 ms-5 me-5 mb-4'>
                            {Object.keys(single_product).length > 0 &&
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th className='bg-grey2'>{t('product')}</th>
                                            <th className='bg-grey2'>{t('manufacturer')}</th>
                                            <th className='bg-grey2'>{t('quantity')}</th>
                                            <th className='bg-grey2'>{t('price')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><NavigateToProductDetail
                                                data={{ ManufacturerName: single_product?.ManufacturerName, ERPMFRPartNumber: single_product?.ERPMFRPartNumber, ItemNumber: single_product?.ItemNumber, ERPPartNumber: single_product?.ERPPartNumber, seoItemNumber: single_product?.seoItemNumber }}>
                                                {single_product.ERPMFRPartNumber}</NavigateToProductDetail>
                                            </td>
                                            <td className='font-bold'>{single_product.ManufacturerName}</td>
                                            <td className='font-bold'>{get_quantity_format(getLatestQuantity())}</td>
                                            <td className='font-bold'>{getLatestQtyAndPrice?.marketPrice ? window.mct : " "} {System.getFormatNumber({
                                                amount: Number(getLatestQtyAndPrice?.marketPrice) || 0,
                                                maximumFractionDigits: 2,
                                                isDisplaySymbol: true
                                            }) || 0}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }
                        </div>

                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary w145"
                            onClick={onHide}>{t('close')}
                        </button>
                        <button type="button" className="bs5 btn btn-primary w145"
                            onClick={() => {
                                window.location.href = BOM.getBomDetailByIdRouteURL(
                                    bom_id,
                                    {
                                        go: System.getParams().go
                                    }
                                )
                            }}>{t('returnToBom')}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddedToBomPopup;